import React from 'react';
import { useTranslation } from 'react-i18next';
import { AR_PROVINCES } from '../../../lib/data/medicalPresets';

// Matrícula provincial + provincia (Consultame, NER-3832). En MVP la matrícula
// es un trust-signal: validación de formato liviana (no vacía, alfanumérica con
// prefijos MP/MN/M opcionales), sin verificación contra colegios profesionales.
// Emite { license, licenseProvince }.

// Formato tolerante: opcional prefijo (MP/MN/M) + separadores + dígitos.
const LICENSE_RE = /^(m[pn]?\.?\s*)?[a-z0-9][a-z0-9.\-\s/]{1,20}$/i;

export function isValidLicense(value) {
  const v = (value || '').trim();
  if (!v) return false;
  return LICENSE_RE.test(v);
}

function MedicalLicenseInput({ value, province, onChange, error }) {
  const { t } = useTranslation();

  const emit = (patch) => {
    onChange({ license: value || '', licenseProvince: province || '', ...patch });
  };

  return (
    <div className="med-field">
      <label className="med-label" htmlFor="license-number">
        {t('setupWizardMedical.professional.license', 'Matrícula provincial')}
      </label>
      <div className="med-license-row">
        <input
          id="license-number"
          type="text"
          className="sw-input med-license-number"
          value={value || ''}
          onChange={(e) => emit({ license: e.target.value })}
          placeholder={t('setupWizardMedical.professional.licensePlaceholder', 'Ej: MP 12345')}
          autoComplete="off"
        />
        <select
          className="sw-input med-license-province"
          value={province || ''}
          onChange={(e) => emit({ licenseProvince: e.target.value })}
          aria-label={t('setupWizardMedical.professional.licenseProvince', 'Provincia de la matrícula')}
        >
          <option value="" disabled>
            {t('setupWizardMedical.professional.licenseProvincePlaceholder', 'Provincia')}
          </option>
          {AR_PROVINCES.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </div>
      <p className="sw-hint med-hint-tight">
        {t(
          'setupWizardMedical.professional.licenseHint',
          'Se muestra a tus pacientes como señal de confianza. No se valida en esta etapa.'
        )}
      </p>
      {error && (
        <p className="sw-error">
          {t('setupWizardMedical.errors.licenseRequired', 'Completá tu matrícula y provincia')}
        </p>
      )}
    </div>
  );
}

export default MedicalLicenseInput;
